var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remote-upgrade"},[(!_vm.showDetail)?_c('Index',{on:{"detail":_vm.handleDetail}}):_c('Detail',{attrs:{"schoolKey":_vm.schoolKey},on:{"back":_vm.handleBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }